/**
 * PasswordToggle.js — wires up .password-toggle buttons to show/hide the
 * password input named by their data-target id.
 */
export default class PasswordToggle {
  constructor(selector = '.password-toggle') {
    this.buttons = document.querySelectorAll(selector);
    if (!this.buttons.length) return;

    this.buttons.forEach((btn) => {
      const input = document.getElementById(btn.dataset.target);
      if (!input) return;

      const icon = btn.querySelector('i');

      btn.addEventListener('click', () => {
        const isHidden = input.type === 'password';
        input.type = isHidden ? 'text' : 'password';
        icon?.classList.toggle('fa-eye', !isHidden);
        icon?.classList.toggle('fa-eye-slash', isHidden);
        btn.setAttribute('aria-label', isHidden ? 'Hide password' : 'Show password');
      });
    });
  }
}
